'use client';

import styled from '@emotion/styled';
import {
	ArrowBackIcon,
	ContentWrap,
	Css,
	ITheme,
	Responsive,
} from '../../../ui';
import { SiteSectionIds } from '../../../contentful';
import { getCurrentAirportCodeFromId } from '../../../components/common/navigation/utils/getCurrentAirportCode';
import { AirportCodes, airportTag } from '../../../types/airports';
import { createContentSearchStore } from '../domain/stores/createContentSearchStore';
import { algoliaSearchService } from '../data/services';
import { PageLayout } from '../../shared/layout/page/PageLayout';
import { Topbar } from '../../../components/common/top-bar/Topbar';
import { SearchPageContent } from './SearchPageContent';
import LinkButton from '../../../components/common/button/LinkButton';
import { Color } from '../../../styles/Color';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';

export interface ISearchPageProps {
	siteSectionId: SiteSectionIds;
}

export function SearchPage({ siteSectionId }: ISearchPageProps) {
	const airportCode = getCurrentAirportCodeFromId(siteSectionId);
	const { tag } = airportTag[airportCode as AirportCodes];
	const store = createContentSearchStore({
		algoliaSearchService,
		airportTag: tag,
		offset: 20,
	});
	let redirectUrl = '';

	if (typeof document !== 'undefined') {
		redirectUrl = document.referrer;
	}

	return (
		<PageLayout>
			<title>Search</title>
			<Topbar siteSectionId={siteSectionId} />

			<PageWrapper>
				<BackLinkWrap>
					<ContentWrap>
						<StyledLinkButton
							icon={<ArrowBackIcon aria-hidden="true" />}
							href={redirectUrl !== '' ? redirectUrl : PageRoutes.Gateway}
							iconPosition="left"
							buttonType="text"
							aria-label="Go back"
						>
							Back
						</StyledLinkButton>
					</ContentWrap>
				</BackLinkWrap>

				<SearchPageContent store={store} />
			</PageWrapper>
		</PageLayout>
	);
}

const BackLinkWrap = styled.div`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 0;
	}
`;

const PageWrapper = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	padding-top: ${Css.pxToRem(40)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-top: ${Css.pxToRem(24)};
	}
`;

const StyledLinkButton = styled(LinkButton)<{}, ITheme>`
	color: ${Color.OnBackground};

	&:hover {
		cursor: pointer;
		color: ${Color.OnBackground};

		svg {
			transform: translateX(-${(props) => props.theme.button?.iconSeparator});
		}
	}
`;
